import { useEffect, useState } from "react";

const links = [
  { label: '官方公告', href: '#announcements' },
  { label: '官方声明', href: '#statements' },
  { label: '消息动态', href: '#dynamics' },
  { label: '资讯看点', href: '#features' },
  { label: '官方渠道', href: '#channels' },
  { label: '帮助中心', href: '#faq' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        solid ? 'bg-background-50/95 backdrop-blur border-b border-background-200/70' : 'bg-transparent'
      }`}
    >
      <div className="mx-auto flex h-16 md:h-[72px] max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2.5">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-xl text-lg ${
              solid ? 'bg-primary-500 text-background-50' : 'bg-background-50/20 text-background-50 backdrop-blur'
            }`}
          >
            <i className="ri-archive-2-fill"></i>
          </span>
          <span
            className={`font-heading text-lg font-bold tracking-wide ${
              solid ? 'text-foreground-950' : 'text-background-50'
            }`}
          >
            吃瓜<span className={solid ? 'text-primary-600' : 'text-secondary-300'}>官网</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                solid
                  ? 'text-foreground-700 hover:bg-secondary-100 hover:text-foreground-950'
                  : 'text-background-100 hover:bg-background-50/15 hover:text-background-50'
              }`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#announcements"
            className={`hidden whitespace-nowrap items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold transition-all sm:inline-flex ${
              solid
                ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                : 'bg-background-50 text-primary-700 hover:bg-background-100'
            }`}
          >
            <i className="ri-notification-3-line text-base"></i>
            订阅动态
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className={`flex h-10 w-10 items-center justify-center rounded-full lg:hidden ${
              solid ? 'text-foreground-900 hover:bg-secondary-100' : 'text-background-50 hover:bg-background-50/15'
            }`}
          >
            <i className={`text-2xl ${open ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {open && (
        <nav className="border-t border-background-200/70 bg-background-50 px-4 pb-5 pt-2 lg:hidden">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="flex items-center gap-2 rounded-lg px-3 py-3 text-sm font-medium text-foreground-800 hover:bg-secondary-100"
            >
              <i className="ri-arrow-right-s-line text-lg text-primary-500"></i>
              {l.label}
            </a>
          ))}
          <a
            href="#announcements"
            onClick={() => setOpen(false)}
            className="mt-2 flex items-center justify-center gap-2 rounded-full bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50"
          >
            <i className="ri-notification-3-line text-base"></i>
            订阅动态
          </a>
        </nav>
      )}
    </header>
  );
}